module.exports = __webpack_public_path__ + "img/vote-table.32c77ea9.svg";